export default __webpack_public_path__ + "static/media/icon_building_24.835698d2.svg";